
import Vue from 'vue'
import { Store } from './store'
import TheSidebar from '@/categories/TheSidebar.vue'
import Features from '@/categories/components/Features.vue'
import HeroImage from '@/categories/components/HeroImage.vue'
import Banner from '@/categories/components/Banner.vue'
import MainContentError from '@/categories/components/MainContentError.vue'
// import CategoryDetails from '@/categories/components/CategoryDetails.vue'
import { LOADSTATUS } from '../common/constants'
import ChildCategorySection from '@/categories/components/ChildCategorySection.vue'
import ProductsSection from '@/categories/components/ProductSection.vue'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'
// import FacetsLink from '@/common/components/facets/FacetsLink.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import ProductList from '@/categories/components/ProductList.vue'
// import SortedProductSection from '@/categories/components/SortedProductSection.vue'
import CmsSection from './components/CmsSection.vue'

export default Vue.extend({
  components: {
    TheSidebar,
    Features,
    HeroImage,
    Banner,
    MainContentError,
    ChildCategorySection,
    ProductsSection,
    BaseImage,
    // ShippingDates,
    // CategoryDetails,
    // FacetsLink,
    ProductList,
    CmsSection
    // SortedProductSection
  },
  props: {
    sharedStore: {
      type: Object as () => Store,
      required: true
    },
    categoryId: {
      type: Number,
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data() {
    return {
      store: this.sharedStore
    }
  },
  computed: {
    isShowBanners(): boolean {
      return this.store.state.banners.length >= 3
    },
    isError(): boolean {
      return this.store.state.loadStatus === LOADSTATUS.ERROR
    },
    isChildCategorySectionVisible(): boolean {
      return !!this.store.state.childCategoriesSection && this.store.state.childCategoriesSection.categoryItems?.length > 0
    },
    isProductSectionVisible(): boolean {
      return this.store.state.loadStatus === 'LOADED'
    },
    isDisableTagSection(): boolean {
      return Object.keys(this.store.state.productSections).length < 2
    },
    isHideProductSection(): boolean {
      return this.isDisableTagSection
    },
    shortDisplayName(): string {
      return this.store.state.basicInformation?.shortDisplayName || ''
    }
  },
  mounted() {
    if (this.store.state.categoryId) this.store.fetchCategoryData()
  },
  created() {
    this.store.setCategoryId(this.categoryId)
    this.store.getSidebarData()
  },
  methods: {
    retryFetchCategoryData(): void {
      this.store.fetchCategoryData()
    }
  }
})
